import React, {Component} from 'react';
import Header from '../wholeDesign/header';
import Details from '../wholeDesign/detail';
import classes2 from './../wholeDesign/scss/bottom.module.scss';
import classes from './../wholeDesign/scss/infoBar.module.scss';

import ReactToPrint from 'react-to-print';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';




class Form extends Component{
    constructor(match){
        super();
        this.state={
            show: true,
            check: false,

            address : '',
            number : 0,
            date : ''

        }
        this.beforePrint = this.beforePrint.bind(this);
        // this.afterPrint = this.afterPrint.bind(this);

        this.onAddressHandler = this.onAddressHandler.bind(this);
        this.onNumberHandler = this.onNumberHandler.bind(this);
        this.onDateHandler = this.onDateHandler.bind(this);
        
    }

    beforePrint(){
            this.setState({
                show: false,
                check: false
           
            })
    }
    checkPrint(address, number, date){
        if (address === '' || number === '' || date === '' ){
            return (
                <div className={classes2.notReady}>PLEASE FILL OUT THE FORM BEFORE YOU PRINT</div>
            );
        }else{
            return(
                <ReactToPrint
                trigger={() => <button className={classes2.bottom} >Print</button>}
                content={() => this.componentRef}
                onBeforeGetContent={this.beforePrint}
                onAfterPrint = {this.afterPrint}
            /> 
            )
        }

    }

    onAddressHandler = (event)=>{
        this.setState({
            address: event.target.value,
        })
    }
    onNumberHandler = (event)=>{
        this.setState({
            number: event.target.value,
        })
    }
    onDateHandler = (event)=>{
        this.setState({
            date: event,
        })
    }
        

    afterPrint(){
        return(
            <ReactToPrint
            trigger={() => <button className={classes2.bottom2} >Print</button>}
           
        /> )
    }
        
    render(){
    
    return(

        <div>
            <div ref={el => (this.componentRef = el)}>
            <Header/>
            <form className={classes.grid} >
                <div className={classes.inputBoxA}>
                    <p>{this.props.match.params.type} address to:</p><br/>
                    <textarea name="address" rows='2' placeholder="Name"  onChange={this.onAddressHandler} value={this.state.address} />
                </div>
                <div className={classes.inputBoxB}>
                    <p>{this.props.match.params.type} no:</p><br/>
                    <input name="number" type="number" onChange={this.onNumberHandler} value={this.state.number}  placeholder="Number" />
                </div>
                <div className={classes.date}>
                    <p>DATE:</p><br/>
                <DayPickerInput onDayChange={day => this.onDateHandler(day)} />
                </div>
                
           
            </form>
            <Details 
                    type={this.props.match.params.type} 
                    currency={this.props.match.params.currency} 
                    unit={this.props.match.params.unit} 
                    show={this.state.show}
            /> 
            
            </div>
            {this.checkPrint(this.state.address, this.state.number, this.state.date)}
           
        </div>
    )
}
}


export default Form;
    

        

